import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { NModalLayoutRight } from '../../../../../ui/modal/modal-layout-right.component';
import { StoreDetailsComponent } from '../../../../store/store-details/store-details.component';
import { LocalStore } from '../../../../store/store.decorator';
export const SEE_IN_STORE_DETAILS_MODAL_ID = 'seeInStoreModalStoreDetails';
@DfModal({
    id: SEE_IN_STORE_DETAILS_MODAL_ID,
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-t-15 p-a-10 p-a-4-s p-t-7-s'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'product-view-see-in-store-modal-store-details',
    templateUrl: './product-view-see-in-store-modal-store-details.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [StoreDetailsComponent, CommonModule]
})
export class ProductViewSeeInStoreModalStoreDetailsComponent {
    constructor(
        @Optional()
        private modalRef: ModalRef<ProductViewSeeInStoreModalStoreDetailsComponent>,
        @Optional()
        @Inject(MODAL_DATA)
        public store: LocalStore) { }
    close() {
        this.modalRef.close();
    }
}
